// import { useHistory } from 'react-router-dom';
// import { useEffect } from 'react';
// Updated: December 13, 2025 - Removed Kyra, updated team structure
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const actions = {
  /** Log in the provided user. Payload is the new user object. */
  LOGIN: "LOGIN",
  // /** Log out the current user. No payload. */
  // LOGOUT: 'LOGOUT',
  /** Display a toast. Payload { String message, Number statusCode } */
  TOAST: "TOAST",
  /** Clear the current toast. No payload. */
  UNTOAST: "UNTOAST",
  /** Set the message list. Payload is an array of messages. */
  UPDATE_MESSAGES: "UPDATE_MESSAGES",
  /** Reset the message lsit. No payload. */
  RESET_MESSAGES: "RESET_MESSAGES",
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.LOGIN:
      return {
        user: {
          ...state.user,
          token: action.payload,
        },
      };
    // case actions.LOGOUT:
    //   return {
    //     user: initialState.user,
    //     toast: toastFor(action, 'Log out successful', 200)
    //   };
    case actions.TOAST:
      return { toast: { ...state.toast, ...action.payload } };
    case actions.UNTOAST:
      return { toast: state.toast };
    case actions.UPDATE_MESSAGES:
      return { messages: action.payload };
    case actions.RESET_MESSAGES:
      return { messages: state.messages };
    default:
      return state;
  }
};

export const pathTitles = {
  HOME: "Home",
  TRAINING: "Training",
  ALLTRAININGPROGRAMS: "All Training Programs",
  PRIVATELESSONS: "Private Lessons",
  BOARDANDTRAIN: "Board And Train",
  BOARDANDTRAINADULT: "Adult Dog Board And Train",
  BOARDANDTRAINPUPPY: "Puppy Board And Train",
  BUYATRAINEDPUPPY: "Buy A Trained Puppy",
  DAYTRAINING: "Day Training",
  BOARDING: "Boarding",
  MEETTHETEAM: "Meet The Family",
  MEETAURORA: "Aurora",
  MEETTHETRAINER: "Meet The Trainer",
  JOINOURTEAM: "Join Our Team",
  MEETMUNCH: "In Memory of Munch",
  MEETSEELEY: "Seeley",
  MEETZETA: "Zeta",
  TESTIMONIALS: "Testimonials",
  FAQ: "FAQ",
  CONTACTUS: "Contact Us",
};

export const useStore = create(
  devtools((set, get) => ({
    dispatch: (args) => set((state) => reducer(state, args)),
    user: {
      token: "",
    },
    messages: [],
    toast: {
      message: "",
      statusCode: 0,
    },
    paths: [
      {
        displayName: pathTitles.HOME,
        path: "/",
        header: true,
        footer: true,
        dropDown: false,
      },
      {
        displayName: pathTitles.TRAINING,
        path: "/training",
        header: false,
        footer: true,
        parentDrop: "train",
        dropDown: false,
      },
      {
        displayName: pathTitles.ALLTRAININGPROGRAMS,
        path: "/training/all",
        header: true,
        footer: false,
        dropDown: "train",
      },
      {
        displayName: pathTitles.PRIVATELESSONS,
        path: "/training/private",
        header: true,
        footer: false,
        dropDown: "train",
      },
      {
        displayName: pathTitles.DAYTRAINING,
        path: "/training/day-training",
        header: true,
        footer: false,
        dropDown: "train",
      },
      {
        displayName: pathTitles.BOARDANDTRAIN,
        path: "/training/board-and-train",
        header: true,
        footer: false,
        parentDrop: "boarding",
        dropDown: "train",
      },
      {
        displayName: pathTitles.BOARDANDTRAINADULT,
        path: "/training/board-and-train-adult",
        header: false,
        footer: false,
        dropDown: "boarding",
      },
      {
        displayName: pathTitles.BOARDANDTRAINPUPPY,
        path: "/training/board-and-train-puppy",
        header: false,
        footer: false,
        dropDown: "boarding",
      },
      {
        displayName: pathTitles.BUYATRAINEDPUPPY,
        path: "/training/buy-a-trained-puppy",
        header: true,
        footer: false,
        dropDown: "train",
      },
      {
        displayName: pathTitles.BOARDING,
        path: "/training/boarding",
        header: false,
        footer: false,
        dropDown: false,
      },
      {
        displayName: pathTitles.MEETTHETEAM,
        path: "/meet-the-trainer",
        header: false,
        footer: true,
        parentDrop: "team",
        dropDown: false,
      },
      {
        displayName: pathTitles.MEETTHETEAM,
        path: "/meet-the-trainer",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.MEETTHETRAINER,
        path: "/meet-the-trainer/justine",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.JOINOURTEAM,
        path: "/meet-the-trainer/join-our-team",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.MEETMUNCH,
        path: "/meet-the-trainer/in-memory-of-munch",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.MEETZETA,
        path: "/meet-the-trainer/zeta",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.MEETAURORA,
        path: "/meet-the-trainer/aurora",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.MEETSEELEY,
        path: "/meet-the-trainer/seeley",
        header: true,
        footer: false,
        dropDown: "team",
      },
      {
        displayName: pathTitles.TESTIMONIALS,
        path: "/testimonials",
        header: true,
        footer: true,
        dropDown: false,
      },
      {
        displayName: pathTitles.CONTACTUS,
        path: "/contact-us",
        header: true,
        footer: true,
        dropDown: false,
      },
      {
        displayName: pathTitles.FAQ,
        path: "/faq",
        header: true,
        footer: true,
        dropDown: false,
      },
    ],
    getLink: (title) => {
      const link = get().paths.find((path) => path.displayName === title).path;
      return link;
    },
    getSnippet: (str) => {
      return `${str.substring(0, 130).trim()}...`;
    },
    buildServices: (service) => {
      return {
        title: get().trainingDetails[service].title,
        info: get().getSnippet(get().trainingDetails[service].body.info),
        link: get().getLink(pathTitles[service]),
      };
    },
    addService: (obj, service, value) => {
      set((state) => ({
        trainingDetails: {
          ...state.trainingDetails,
          [obj]: {
            ...state.trainingDetails[obj],
            body: {
              ...state.trainingDetails[obj].body,
              otherServices: {
                ...state.trainingDetails[obj].body.otherServices,
                [service]: get().buildServices(value),
              },
            },
          },
        },
      }));
    },
    checkServices: (obj) => {
      for (const type in obj) {
        if ("otherServices" in obj[type].body) {
          for (const service in obj[type].body.otherServices) {
            let value = obj[type].body.otherServices[service];
            if (typeof value == "string") {
              get().addService(type, service, value);
            }
          }
        }
      }
      set({
        loading: false,
      });
    },
    loading: true,
    setLoading: (load) => {
      set({
        loading: load,
      });
    },
    trainingDetails: {
      ALLTRAININGPROGRAMS: {
        body: {
          title:
            "We offer an exceptional training experience for puppies and dogs.",
          info: "Todo’s Translator is here to provide an enjoyable and effective training experience for both you and your dog.   Choose in home lessons alone to teach you how to train your dog yourself or get extra help from Todo’s owner and trainer, Justine, through Day Training or Board and Train.   Justine is here to help you learn how to have a more peaceful relationship with your dog.",
          image: "trainingAll",
          imageCaption:
            "Grace and friends practice holding a down while Justine cooks dinner.",
          otherServices: {
            privateLessons: "PRIVATELESSONS",
            dayTraining: "DAYTRAINING",
            boardAndTrain: "BOARDANDTRAIN",
            buyAPuppy: "BUYATRAINEDPUPPY",
          },
          moreInfo: [
            "How to start? Contact us to schedule a non-committal Consultation ($40) to make a Training Plan specific to your situation and goals.",
          ],
        },
      },
      PRIVATELESSONS: {
        title: pathTitles.PRIVATELESSONS,
        body: {
          title:
            "Give your dog the best experience with our private dog training program.",
          info: "Does your dog sometimes have a hard time being around other dogs? Is your dog easily excitable around other furry friends? If so, you should take advantage of our private dog training program offered right here in Indianapolis, Indiana. Our experienced, dedicated, and qualified owner has loved dogs ever since she was young. Today, she has over 7 years of experience as a professional dog trainer, and a lifetime as a pet owner.",
          image: "privateLessons",
          imageCaption:
            "A client's dog out to lunch with Justine, practicing positive associations with dogs and people as well as impulse control.",
          moreInfo: [
            "All programs offered will include Lessons for the owners to learn how to work with their dog in their home or where the problem behaviors are occurring.  With years of experience and hundreds of dogs trained Justine is able to offer you individualized solutions to your dog related problems.",
            "During lessons we will focus on teaching you how to handle your dog in a way that reinforces wanted behaviors and makes unwanted behaviors less successful to your dog (and therefore less likely to be repeated).",
            "Keep in mind that dog training is a process. It is daily routine and proper communication with our dogs. It is hard work creating a relationship built on trust and fellowship. Just like everything in life the more you put into it the more you get out of it. Do your best to make training your dog a lifestyle.",
            "Private lessons are a great option for Justine to teach you how to train your dog. Because a large majority of dog training is repetition it is up to you to do the reps. Just like going to the gym, you must work on a regular basis with your dog to attain your goals.",
            "To be sure that you get the most out of your training sessions please make your priorities clear so that the focus is on what is important to you. Justine’s goal is to leave you with enough understanding of how to train dogs that you become her “apprentice dog trainers”.",
          ],
        },
      },
      BOARDANDTRAIN: {
        title: pathTitles.BOARDANDTRAIN,
        body: {
          title:
            "Our boarding and training programs are available for puppies and dogs.",
          info: "At Todo's Translator, we offer a unique boarding and training experience for puppies and dogs that provides a 24/7 immersive training experience. Your dog receives real-world environment training that translates perfectly into your home lifestyle. During a Board and Train through Todo’s Translator your dog goes to live with owner and trainer, Justine in her home for a faster paced, more immersive solution. Your dog will be practicing calm polite behavior every minute of the day. They also will be treated as a member of the family with lots of love, cuddles and play time in the half acre yard with other dogs.",
          image: "boardAndTrain",
          imageCaption:
            "Board and train dogs in Justine's living room, practicing positive associations with cats and impulse control in real life environments.",
          moreInfo: [
            "Board and Train is the fastest, most effective way to see a dramatic change in your dog’s behavior.",
          ],
          otherServices: {
            puppyTraining: "BOARDANDTRAINPUPPY",
            boardAndTrain: "BOARDANDTRAINADULT",
          },
        },
      },
      BOARDANDTRAINADULT: {
        title: pathTitles.BOARDANDTRAINADULT,
        body: {
          title:
            "Obedience training comes with a number of benefits for both you and your dog.",
          info: "Finding the right dog trainer can be tough, but the Todo's Translator team is here to provide this important service. We offer obedience training to dogs located throughout the Indianapolis, Indiana area. The most effective, fast paced option available to train your dog is Board and Train. Your dog would come to live with Justin, owner & trainer, and her family in their home for the most intensive part of its training. Every dog who comes to stay is treated as one of the pack. While there is a lot of training and work that gets done there is also plenty of snuggles, play time and rest. Enjoy peace of mind knowing that Justine will do all the hard work and your dog will be happy and well cared for.",
          image: "btAdult",
          imageCaption:
            "Jax on walk with Justine, working on reactivity towards people, leaf blowing, cars, and dogs.",
          moreInfo: [
            "Obedience training comes with a number of benefits for both you and your dog. Many public places allow well-behaved dogs, including stores, public beaches, and outdoor event venues. You might also take a trained dog on a hike or swimming in a public lake. When properly trained, a dog can participate in many of the activities that you and your family enjoy doing. Obedience training can also help to keep your dog safe, as they’ll respond to your commands and exhibit good behavior in a wide range of circumstances and situations.",
            "You can choose from several obedience training options, depending on the age of your dog and what you want to get out of the experience. We offer several board-and-train programs, which involve leaving your dog with us for several weeks for boarding and professional training. You can also schedule your dog for one-on-one private training or in-home training lessons. Check out all our different programs to see what you feel is best for your dog!",
          ],
          otherServices: {
            puppyTraining: "BOARDANDTRAINPUPPY",
            privateLessons: "PRIVATELESSONS",
          },
        },
      },
      BOARDANDTRAINPUPPY: {
        title: pathTitles.BOARDANDTRAINPUPPY,
        body: {
          title:
            "Our puppy training will get your puppy started out on the right paw.",
          info: "There is a lot to be said for getting started early with dog training. At Todo's Translator, we offer three puppy programs for puppies between 9 weeks and 4 months of age. We do all the foundational work for your puppy. This includes starting crate training, potty training, socialization, and all basic obedience at a puppy level. Your puppy will also get much needed exposure/socialization. You select the amount of time your dog stays with us. These programs do not get you a fully trained dog, but it gets them started out on the right track.",
          image: "btPuppy",
          imageCaption: "Rowan taking a nap on Justine's back porch.",
          moreInfo: [
            "As your puppy grows, you can shift from puppy training to our other dog training offerings. You can choose from the board and train experience or as additional one-on-one lessons that go over the next phase of dog training, namely basic obedience. Let us know if you have any questions about our puppy training or other services.",
          ],
          otherServices: {
            privateLessons: "PRIVATELESSONS",
            boardAndTrain: "BOARDANDTRAINADULT",
          },
        },
      },
      BUYATRAINEDPUPPY: {
        title: pathTitles.BUYATRAINEDPUPPY,
        body: {
          title:
            "A Trained Puppy from Todo’s Translator has the knowledge and experience necessary to behave as we expect a ‘good dog’ to behave.",
          info: "The puppy will learn how to live a cooperative life with humans; what is allowed, what isn’t, and how to be an all around family dog. Each puppy is handpicked and hand raised by Justine in her home with her dog pack.  Justine starts by searching for the right breeder.  Many aspects of a dog’s overall health and temperament are determined by genetics and early experiences so choosing the right breeder is vital. Once she chooses the breeder she makes sure that she chooses the right litter and right pup.  Justine checks the health and temperament of both parents, then watch how the puppies interact with one another to be sure she brings the perfect personality home.",
          image: "buyATrainedPuppy",
          imageCaption:
            "Tinker, Rukus, and Grace - all sold trained puppies - learned what swimming was and how to do it!",
          otherServices: {
            buyAPupWeb: {
              title: "Ready to find your new family member?",
              info: "The thought of raising a new puppy on your own is overwhelming. You want a dog that will fit perfectly with your lifestyle. Your life...",
              link: "https://buyatrainedpuppy.com/trained-puppies-for-sale",
            },
            puppyTraining: "BOARDANDTRAINPUPPY",
          },
        },
      },
      DAYTRAINING: {
        title: pathTitles.DAYTRAINING,
        body: {
          title:
            "Day Training is an opportunity for Justine to take on some of the repetition for you.",
          info: "Day Training is for your dog to spend time with Justine one on one – no owners.  Justine spends up to 3 hours per session with your dog working on specific goals.  These sessions are great for extra repetition, to troubleshoot problems, or to introduce tools.  Justine may work with your dog in your home or out in public.  Day Training is always followed by a lesson the next day to teach you what your dog has learned.",
          image: "dayTraining",
          imageCaption:
            "Dogs practicing a stay command inside the house while their owners work in the garden with the garage door open.",
          moreInfo: [
            "During a ‘Day Training’ session Justine will pick your dog up in the morning, he will spend the day working towards the goals we had agreed upon during our consultation, and Justine will return him to you in the evening and spend 30 minutes teaching you what Justine has taught him.",
            "This program is ideal for:",
            "- Owners who don’t have the time necessary to address their dog’s issue(s)",
            "- Dogs who need more one on one time with the trainer",
            "- Dogs who do not do well when left home alone during the day",
            "- Puppy Raising, house training and socialization",
            "- New rescue dogs that need help adjusting",
            "- Troubleshooting (ex: dog won'the perform outside/in public, leash pulling, etc)",
            "NOTE: This is unlike training programs at boarding/daycare facilities.  Justine will be spending the day with only your dog, instead of one training session while your dog spends the rest of the day at daycare.   Whether your pup realizes it or not he will be learning all day long.  We will train, play, take a break, repeat.  Even when he’s taking a break he will still be learning how to be a relaxed, calm guy.  Training will occur in whatever environment is conducive to your dog’s learning style. This can include in the car, at my home, in my half acre fenced yard, on walks, on the Monon Trail, at dog friendly restaurants, pet stores, or possibly dog parks (if your dog has a tag).   Whichever environment works best for your dog at that point in his education is where we will practice.  The activities your dog and Justine do will reflect your lifestyle and training goals and will therefore be more productive in the long run.",
          ],
          otherServices: {
            buyAPuppy: "BUYATRAINEDPUPPY",
            privateLessons: "PRIVATELESSONS",
          },
        },
      },
      BOARDING: {
        displayName: pathTitles.BOARDING,
        body: {
          title:
            "We offer a different kind of dog boarding experience we think you and your dog will love.",
          info: "There are many dog boarding facilities out there that focus only on providing a safe place for your dog to be when you have to go out of town on business or vacation. Here at Sublime K9 Training & Boarding, our primary focus is on dog training where your dog stays with us while we get them trained for you. Dog boarding is part of the board & train process in this case. However, we do offer regular dog boarding when space allows.",
          image: "boardAndTrain",
          imageCaption:
            "Boarding dogs relaxing in Justine's living room, practicing calm behavior around cats and other real-life distractions.",
          moreInfo: [
            "Our dog boarding experience includes as many let outs as your dog needs, and if your dog is social, it also includes plenty of supervised playtime with other dogs! You must pack your dog’s own food. All dogs must be current on all vaccines, including kennel cough.​",
            "Our kennel runs are indoor only and 4 ft by 4 ft. Each has its own raised dog bed for comfort, and blankets are welcome as long as your dog does not chew them. We chose to do indoor only kennels because giving your dog the outdoor option can create a bad habit of allowing your dog to use the bathroom inside the kennel. Our boarded dogs spend most of their time outside of their kennel, socializing and playing. Kennel time is for down time, feeding times, and bed time! We want your dog’s stress levels and energy levels low, so we strive to make your dog’s boarding experience fun!",
          ],
          otherServices: {
            privateLessons: "PRIVATELESSONS",
            boardAndTrain: "BOARDANDTRAIN",
          },
        },
      },
    },
    aboutDetails: {
      THETEAM: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "From our family to yours.",
          info: "Justine Ramey is the owner and trainer at Todo’s Translator. Justine opened Todo’s for business in 2015 to help owners to have more peaceful lives with their dogs.  She wants all dog owners to understand how to have a life with their dogs that is enjoyable and fullfilling.  Justine is a member of the Association of Pet Dog Trainers and the International Assosiation of Canine Professionals.  She is constantly looking to grow and expand her knowledge base through relationships with other trainers, conferences and workshops.",
          image: "theTeam",
          imageCaption: "Justine with Buy A Trained Puppy graduates.",
          moreInfo: [
            "Justine wants to teach you how to have a dog that works for you because he ENJOYS it, respects you and values your relationship.",
            "Justine lives with her son, Foster, and their pack. They have Zeta, the Pitbull Mix, who is chatty and loves all humans, and Aurora, the Cane Corso Mastiff, whose happiness can be seen in her hips.",
          ],
          otherMembers: {
            JOINTEAM: {
              title: "Join Our Team",
              info: "Are you passionate about dogs and interested in a career in dog training? We're always looking for dedicated individuals who share our love for helping dogs and their owners build better relationships.",
              link: "/meet-the-trainer/join-our-team",
              image: "theTeam",
              imageCaption: "Become part of the Todo's Translator family.",
            },
            MUNCH: {
              title: "In Memory of Munch",
              info: "Munch was Justine's first dog and the inspiration behind Todo's Translator. This little Dachshund taught Justine that behavior was her calling, not veterinary medicine. He will always hold a special place in our hearts.",
              link: "/meet-the-trainer/in-memory-of-munch",
              image: "munch",
              imageCaption: "Munch, forever in our hearts. 2007-2024.",
            },
            ZETA: {
              title: "Meet Zeta",
              info: "A vocal, eager to please, hard worker. Zeta doesn't make fast friends, unless they're humans! She prefers to play tug, chase, or do any command asked than jump into the dog pile. Zeta is a family favorite here and would love to show you why if you'd just lay on the floor for a second.",
              link: "/meet-the-trainer/zeta",
              image: "zeta",
              imageCaption: "Zeta is ready for Justine's next request.",
            },
            AURORA: {
              title: "Meet Aurora",
              info: "AKC registered, 2 year old, Cane Corso. Aurora naturally grew into that beautiful dog show stride. With a docked tail, she shakes her entire backend to express her happiness - preferably in your face. Her favorite activities include stealing Zeta's ball, jumping the gate Mom (Justine) just closed, and show the new kids how we do things.",
              link: "/meet-the-trainer/aurora",
              image: "aurora",
              imageCaption: "Aurora taking a rest in the sun.",
            },
            SEELEY: {
              title: "Meet Seeley",
              info: "Seeley, the Siamese cat, is an absolutely gorgeous 5 year old, Siamese. While some cats are full of affection and others are aloof; Seeley is a blend of both. In true cat style, he demands attention when he wants it, lies lazily around the house when he doesn't, and comes running when he hears training sessions begin. He will even demand to go with on dog walks.",
              link: "/meet-the-trainer/seeley",
              image: "seeley",
              imageCaption:
                "Seeley the Siamese cat, supervising a training session from his favorite spot.",
            },
            GUESTS: {
              title: "Guest Helpers",
              info: "Many of our board and train puppies and dogs end up helping in lessons.  This helps the client who's lesson it is as well as the helper dog.   This is an opportunity for both to learn appropriate communication (dog/dog) as well as practice obedience and impulse control around other distractions.",
              link: "",
              image: "guests",
              imageCaption:
                "Justine walking Chico, Chester, Charlie, and Bear - all of whom came to her unable to walk on a leash.",
            },
          },
        },
      },
      JOINOURTEAM: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "Join Our Team",
          info: "Are you passionate about dogs and interested in a career in dog training? Todo's Translator is always looking for dedicated individuals who share our love for helping dogs and their owners build better relationships.",
          image: "theTeam",
          imageCaption: "Become part of the Todo's Translator family.",
          moreInfo: [
            "We value patience, compassion, and a genuine love for animals. If you're interested in learning the art of dog training and becoming part of our family, we'd love to hear from you!",
            "To apply, please send your resume and a brief introduction about yourself and your experience with dogs to our contact form. Tell us why you're passionate about dog training and what you hope to bring to our team.",
          ],
        },
      },
      JUSTINE: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "The Team: Justine",
          info: "Justine Ramey is the owner and trainer at Todo’s Translator. She has always had a strong love for animals and for a long time believed that to work with animals she had to become a veterinarian.  Justine embarked upon that path and attended college as a pre-vet student. While the necropsies and physiology classes were fascinating, it wasn’t until she took Ethology (the study of Animal Behavior) that she found her true passion. Justine volunteered at animal shelters, and worked in pet shops. She got a job training dogs at PetsMart. Her life led her to Indianapolis where she got a job as the trainer at a boarding facility. It was here that she saw so many loving owners struggling with seemingly out of control dogs. Justine started by helping some of the boarding facility clients by doing more in depth training. She enrolled in training seminars and conferences, and soon after opened Todo's Translator.",
          image: "teamjustine",
          imageCaption:
            "Aurora and Zeta showing Justine a little appreciation.",
          moreInfo: [
            "Justine lives with her son, Foster, and their pack. They have Zeta, the Pitbull Mix, who is chatty and loves all humans, and Aurora, the Cane Corso Mastiff, whose happiness can be seen in her hips. Munch, the Dachshund who started it all, will always hold a special place in their hearts.",
            "Justine opened Todo’s Translator 5 years ago to help more dogs stay in forever homes, to help owners to fully enjoy their canine companions and to further the bond we share with our four-legged family members.",
            "Mostly, Justine wants you to have a stress-free relationship with your pooch!",
            "Justine chooses to do one on one type sessions because the success of the work depends on several factors; personality of dog and owner, what training method works best for the dog as an individual, what energy level the dog is, what motivates the dog and how motivated the owner is to make a change.  One on one sessions allow Justine to get to know your dog as an individual and to learn exactly what may work best for your personal situation.",
            "Methods:   No Force, Just Fun!",
            "Justine prides herself on using non-forceful training methods.  She uses a combination of positive reinforcement, clicker training and communicating with dogs by using and reading body language.  Her goal is to see a relationship based on mutual respect between all members of your family; two and four legged. This requires using the appropriate training tools properly, clear ‘house rules’, patience and most importantly consistency.",
            "She wants to teach you how to have a dog that wants to work for you because he enjoys it and respects you.  It’s all about communication!",
          ],
        },
      },
      MUNCH: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "In Loving Memory of Munch",
          info: "Munch was the one who started it all. Way back in 2007, Justine got her first dog of her own – Munch, a spirited Dachshund. Justine was a pre-vet student in college when Munch's puppy class coincided with a class she took on Ethology (the study of animal behavior). It was then she realized behavior was her jam, not medicine. And their journey began.",
          image: "teammunch",
          imageCaption: "Munch, forever in our hearts. 2007-2024.",
          moreInfo: [
            "Munch lived a long, wonderful life full of love, treats, and the occasional bird chase in the backyard. He was a treasure who taught Justine everything about patience, communication, and the deep bond between humans and dogs.",
            "While Munch is no longer with us, his spirit lives on in every dog Justine trains and every owner she helps. He was the inspiration behind Todo's Translator, and his legacy continues through the countless dogs and families whose lives have been changed for the better.",
            "Rest easy, sweet boy. You will never be forgotten. 🐾",
          ],
        },
      },
      ZETA: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "The Pack: The Story of Zeta",
          info: "Zeta came to join our family in 2016.  She is some kind of mystery pitbull mutt that was given to us when we lived in Fountain Square.  Zeta has always been a tenacious and smart little thing.",
          image: "teamzeta",
          imageCaption: "Zeta races to greet the photographer.",
          moreInfo: [
            "Zeta prefers to not be with guest dogs. She has her small social group and that's enough for her and we are ok with that.  Zeta is one of the best dogs Justine has ever known and is a joy to train and share life with.",
          ],
        },
      },
      AURORA: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "The Pack: The Story of Aurora",
          info: "Aurora is the baby of the family.  She was born in 2020 from a local Cane Corso breeder.  Justine temperament tested the litters of 14 puppies over several weeks to choose the right work dog.  When reviewing the video of the tests Justine noticed that one puppy in particular was always engaging and interacting with her.  Justine believes Aurora chose her.",
          image: "teamaurora",
          imageCaption:
            "Aurora sits in Justine's lap, loving every minute of attention.",
          moreInfo: [
            "A week after picking Aurora up from the breeder the country went into quarantine for covid-19.  Even as a dog trainer it's difficult to socialize a guardian breed when no one is around to socialize with.   So, Aurora is our covid puppy but still a fabulous work dog.  She has a bit more work to do (don't we all) to be where Justine wants her but we nickname her 'mama' because she is such a good mama dog to all the guests.",
          ],
        },
      },
      SEELEY: {
        title: pathTitles.MEETTHETEAM,
        body: {
          title: "The Pack: The Story of Seeley",
          info: "Seeley Booth, named for the protagonist on the TV show Bones because he is so handsome, is our resident siamese cat.",
          image: "teamseeley",
          imageCaption:
            "Seeley the Siamese cat, ready to join the next training session.",
          moreInfo: [
            "Seeley can't seem to decide if he is a cat or a dog.  When he hears dog training happening he shows up.  Seeley can come when called, sit, paw, spin, get into heel position and is working on weaving between legs.  He is also very good at socializing dogs to cats because he is unperturbed by them and will also put them in their place if he needs to.",
          ],
        },
      },
    },
    testimonials: [
      {
        clientName: "Carrie",
        location: "Fishers, IN",
        comment:
          "Justine, thank you so much for your help! Dora has been so much easier to handle since we began our lessons! As you know, we first hired a trainer that used a prong collar on her and we noticed she would sometimes react worse when she encountered a dog because of it.  I am so glad that we found you!",
      },
      {
        clientName: "Megan",
        location: "Geist, IN",
        comment:
          "Justine I have to tell you how great it is to walk Snickers and not feel embarrassed!  Remember the neighbor that had made so many complaints to the Neighborhood Association? Well yesterday she came up and pet him and told me that I must’ve traded dogs with someone!  I can’t believe it!",
      },
      {
        clientName: "Janel",
        location: "Fishers, IN",
        comment:
          "Bear has been a completely new dog since he came back from his board and train!  Thanks for taking the time to make sure we knew how to handle him just like you can.",
      },
      {
        clientName: "Joe",
        location: "Indianpolis, IN",
        comment:
          "I would highly recommend hiring Todo’s Translator to help train your dog. Justine helped us with our puppy (we started at 5 months) to stop nipping, barking, pulling on leash and pooing inside.  She helped us to understand how our puppy learned those habits and how to break them.  Whenever I have a friend that gets a puppy I send them to her!",
      },
      {
        clientName: "Carl",
        location: "Carmel, IN",
        comment:
          "Justine, I am amazed with the improvements Callie has made since we first started working together.  She still sometimes gets overexcited but now I know how to handle her and help her to calm herself.  Thank you!",
      },
      {
        clientName: "Josh",
        location: "Noblesville, IN",
        comment:
          "I was skeptical when we first started working together.  I didn’t really think that {Nothing in Life is Free} would help Charlie respect me but it does!  It’s only been a few months since you suggested I make him work for everything that he gets from me and he now asks politely from anything he wants from me.  He even asks politely at the pet stores too.  Thanks for helping it all come together.",
      },
      {
        clientName: "Marge",
        location: "Indianpolis, IN",
        comment:
          "Justine impressed me immediately when she showed up exactly on time.  The week before PetPeople referred me to Justine I had scheduled an appointment with another trainer.  That trainer never showed up.  Honestly, I’m glad the first trainer didn’t bother coming because I never would have found Justine otherwise.  A few months later when I experienced health issues Justine sent me the kindest card and helped me to take care of my dog when I was too ill to do so.  I never would have expected to find a friend when I hired a dog trainer!",
      },
    ],
    getWindow: () => {
      set({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    },
    width: 0,
    height: 0,
    googleReviews: [
      {
        profileImage:
          "https://lh3.googleusercontent.com/a-/AOh14GjgRWGvDHyUc2_VrRc8eW1iWx8BB0kOdxSNMV2g2A=s40-c-c0x00000000-cc-rp-mo-br100",
        reviewerName: "Kimmie",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "Justine is the dog whisperer! Our 8 month old Aussie went to training with her for 4 weeks. Prior to training, he chewed everything in sight and jumped on people none stop. He had so much energy and we needed help figuring out how to help channel that energy and get him to behave. He was out of control! Since being home, he has not chewed anything, he tolerates new people and has improved 100000%,& he actually is just chill. We can finally enjoy our dog! This training has been a game changer. We appreciate everything and will always refer Justine! Hands down a miracle worker for our Aussie! *I think Jax misses you every now and then",
        images: [
          "https://lh5.googleusercontent.com/p/AF1QipMqmkTjNYPmX0q-j8JKx396eAlQt7umjMnZd4tr=w100-h100-p-n-k-no",
          "https://lh5.googleusercontent.com/p/AF1QipOCJvZodDvbh0Pqntivgd0hFizYnCtWUGUMKN5y=w100-h100-p-n-k-no",
          "https://lh5.googleusercontent.com/p/AF1QipMxgSwHaSVwjTTKzSnUq_6ieI1mIo8OUuWDvmRK=w100-h100-p-n-k-no",
        ],
      },
      {
        profileImage: "",
        reviewerName: "Pamela",
        stars: 5,
        positive: true,
        keywords: "",
        review:
          "Justine did an amazing job with my new puppy. He was stubborn but she was able to get him to be a good dog.",
        images: [
          "https://lh5.googleusercontent.com/p/AF1QipPzf5YT4uxiySn5RVO6MvwWcvj-jrGfu5rJMC99=w100-h100-p-n-k-no",
        ],
      },
      {
        profileImage:
          "https://lh3.googleusercontent.com/a-/AFdZucp9MjOpBkWE5k1hNacc49y-iJsaD6MGkyZpDUqR_Q=w60-h60-p-rp-mo-ba2-br100",
        reviewerName: "Ashley",
        stars: 5,
        positive: true,
        keywords: "Professionalism, Quality, Reliability",
        review:
          "Justine is AMAZING!!! She did miracles with my lab and continues to support me with tips and tricks even almost a year later!!! You will NOT be disappointed!",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Angie",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "Justine did an amazing job with our puppy. She not only trains your dog but also trains you so that you know what to do. Highly recommend!!",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Sophia",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "Justine is amazing! She is always prepared, on time and patient with our sweet pup. We are proud of the progress our dog continues to make and we owe it all to Justine. We highly recommend her!!",
        images: [
          "https://lh5.googleusercontent.com/p/AF1QipMZDGcLWZs08i0nqEN7Qb2Hpj5UqNTMlneL7vO_=w100-h100-p-n-k-no",
        ],
      },
      {
        profileImage:
          "https://lh3.googleusercontent.com/a-/AFdZucpl8xjsLL9CxaCN057fjFcKeLc_ZKAf59_YHaH-iP4=w60-h60-p-rp-mo-br100",
        reviewerName: "Ryan",
        stars: 5,
        positive: true,
        keywords: "Professionalism, Quality",
        review:
          "Love Justine! She is fluent on multiple training methods and ideologies and will work with you to find the best plan of action for your dog and the results you are looking for. Very personable as well and easy to get along with.",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Allisa",
        stars: 5,
        positive: true,
        keywords: "Professionalism, Quality, Reliability, Responsiveness",
        review:
          "Super down to earth, knowledable and understanding trainer. I've worked with some that are harsh and almost rude, but shes compassionate and listens!  She worked with my pup Koda for his leash reactivity for 2 lessons an hr each and I could see a dramatic difference in just two lessons. Now its my time to take what she taught us and practice!  Would highly recommend!",
        images: [],
      },
      {
        profileImage: "",
        reviewerName: "Christina",
        stars: 5,
        positive: true,
        keywords:
          "Professionalism, Quality, Reliability, Responsiveness, Value",
        review:
          "My dog, Elvis (75 lb. boxer/lab), pulled on his harness for walks. He was out-of-control jumping on us and barking at guests during visits. He had high-anxiety and was (sometimes still is) very stubborn. Todo’s not only trained Elvis to stop pulling on a walk, she trained Elvis to walk next to me on a gentle collar. He now ignores distractions by focusing on me. He doesn’t jump on us and doesn’t bark insanely at visitors. It’s a different dog. Elvis is happier, has less anxiety, and has more control knowing the cues and what action to take. His routine gives him peace. We are no longer frustrated with our loving dog. Our entire house is a better place. Thank you for helping all of us - humans and pups!",
        images: [],
      },
    ],
    inHomePrograms: [
      {
        programName: "Simply Manners Program",
        definition:
          "This program covers your bases to have a calm, polite four legged family member. If you’re looking for your pooch to be more attentive, to listen better and to understand basic commands this is the package for you! You will be taught the initial stages of most basic obedience commands, the key elements of how dogs learn and how to provide your pooch with routine and structure.",
        included: [
          "3 Private In Home Training Sessions at a time convenient for you",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Training Equipment for each session",
          "Sit, Down, Stay, Wait, Gentle, Leave It, Drop It, Touch",
          "Briefly cover common problem behaviors; housebreaking, jumping up, barking, etc.",
          "Handouts, related articles and weekly homework",
          "Graduation Certificate: Basic Obedience",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$550",
        expectations: [
          "Basic understanding of why dogs do what they dog and how they learn",
          "Basic understanding of how to solve/prevent common problem behaviors",
          "Dog will have basic knowledge of obedience skills",
        ],
        image: "program_simply_manners",
      },
      {
        programName: "Simply Manners Plus Leash Walking Program",
        definition:
          "Does your dog need to learn manners both inside and on a leash? If so, this may be the program for you. You will be taught the fundamental skills to train your dog the early stages of basic manners and loose leash walking.",
        included: [
          "6 One Hour Private In Home Lessons",
          "1 Day Training Lesson",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Sit, Down, Stay, Wait, Gentle, Leave It, Drop It, Touch, Come + Loose Leash Walking",
          "Briefly cover common problem behaviors; housebreaking, jumping up, barking, etc.",
          "Handouts, related articles and weekly homework",
          "Photo of you and your pooch",
          "5% Discount on future Services including boarding",
          "Graduation Certificate: Intermediate Obedience",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$1050",
        expectations: [
          "Understand why dogs do what they dog and how they learn",
          "Understand how to solve/prevent common problem behaviors",
          "Reduction in problem behaviors",
          "Dog will have basic knowledge of obedience skills",
          "Early stages of recall (coming when called)",
          "Human will understand how to begin teaching a loose leash walk",
          "Dog will have the beginnings of a loose leash walk",
        ],
        image: "program_simply_manners_plus_leash",
      },
      {
        programName: "Ultimate Family Dog",
        definition:
          "This is the package for the dog owners who want to be involved in their dog’s education and take that education to the next level. Includes Simply Manners plus Leash Walking. Now that your pooch knows what each command means how do we ensure that he performs every time you ask, no matter what? Justine will be happy to teach you!",
        included: [
          "8 One Hour Private In Home Lessons",
          "2 Day Training Sessions",
          "FREE Follow Up Session upon completion for Real World Application",
          "Training Equipment (including Head Halter or Front Clip Harness)",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Sit, Down, Stay, Wait, Gentle, Leave It, Drop It, Touch, Come, Loose Leash Walking, Recall (come when called) and a few tricks!",
          "Learn how to generalize these behaviors so your dog performs in all situations.",
          "Handouts, related articles and weekly homework",
          "CGC, or Canine Good Citizen, testing can be added on for $25",
          "Photo of you and your pooch",
          "10% Discount on future Services including boarding",
          "Graduation Certificate: Advanced Obedience",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$1495",
        expectations: [
          "Understand why dogs do what they dog and how they learn",
          "Understand how to solve/prevent common problem behaviors",
          "Reduction, possible elimination, in problem behaviors",
          "Dog and human will understand how to work as a team and use their obedience skills in most scenarios",
          "Human will understand how to teach a loose leash walk",
          "Dog will loose leash walk",
        ],
        image: "program_ultimate_family_dog",
      },
      {
        programName: "Feisty Fido - Behavioral Modification Program",
        definition:
          "This is the program for dogs who have issues beyond what basic manners can repair (shy, overexcited and reactive dogs) and the owners who want to actively help their dog to recovery. We will begin by learning manners to help your pooch learn to focus and work for what he wants. After you and your dog have learned basic commands and how to work as a team Justine will tailor make a plan to address your specific needs. Frequently this includes teaching you Behavior Adjustment Training and/or Counter Conditioning/Desensitization. This program may or may not include leash walking depending on your dog’s specific needs.",
        included: [
          "6 One Hour Private In Home Lessons",
          "4 Day Training Sessions",
          "2 FREE Follow Up Sessions upon completion for Real World Application",
          "Training Equipment (including Head Halter or Front Clip Harness)",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Basic Obedience commands - depend on your needs - Focus wil be on teaching your pooch calm, polite behavior.",
          "Handouts, related articles and weekly homework",
          "Photo of you and your pooch",
          "10% Discount on future Services including boarding",
          "Graduation Certificate: Life Skills",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$1675",
        expectations: [
          "NOTE: Depending on your particular situation your dog may require more or fewer sessions.",
        ],
        image: "program_fiesty_fido",
      },
      {
        programName: "Unlimited Lifetime Lessons Program",
        definition:
          "If you have serious long term goals to attain this is your package! This package can be used to raise a puppy to adulthood, address serious behavioral issues or to train your dog to go off leash. Don't restrict yourself with limited access to the trainer - go unlimited! After buying this package all you'll need is the dog! Good for the life of your dog(s).",
        included: [
          "Unlimited Private In Home Lessons",
          "Up to 5 Day Training Sessions",
          "All necessary Training Equipment (including Long Line and Leash Walking Equipment)",
          "Unlimited Obedience commands - If you can think it, we can do it! - Unlimited tricks!",
          "20% Discount on future Services including boarding",
          "Unlimted Graduation Certificates",
          "Unlimited Access to the Trainer",
        ],
        cost: "$3750",
        expectations: [
          "ALL of your training goals are met",
          "ALL refresher courses included for the life of your dog",
          "Anything you can dream we can accomplish together!",
        ],
        image: "program_unlimited",
      },
    ],
    btAdultPrograms: [
      {
        programName: "Starter Family Dog Program",
        definition:
          "This is the perfect program to kick start good habits. Studies show that dogs, like humans, need three weeks to form a new habit. We will focus heavily on making good choices pay better than ‘bad’ choices do from your dog’s perspective. We start with generalized impulse control then add in leash walking and basic commands. It will be essential for you to complete lessons and maintain your dog’s new habits.",
        included: [
          "3 Weeks intensive training in the trainer’s home with her pack",
          "5 In Home Private Training Sessions",
          "Recommended 4 sessions completed by go home day",
          "Homework and relevant articles for each training session",
          "All training Equipment (leash walking tool, long leash, cot)",
          "Picture and Video updates during your dog’s stay",
          "Upon Drop Off you can expect reduction in problem behaviors and a fundamental understanding of basic obedience under mild distractions",
        ],
        cost: "$2750",
        expectations: [
          "Reduction in problem behaviors such as jumping, begging, barking and nipping",
          "Dog has fundamental understanding of sit, down, wait, stay, leave it, drop it, gentle, off under mild distractions",
          "Dog understands and responds to sound that means ‘no’ and sound that means ‘yes’",
          "Learned calmness",
        ],
        // image: "btpuppy",
      },
      {
        programName: "Show Off Family Dog Program",
        definition:
          "This program is the starter program plus extras. Your pooch comes to live with me and I will teach him basic manners, loose leash walking and to eliminate common unwanted behaviors. Once I have taught your pup basic commands I will proof them (make the behavior more solid) by practicing the behaviors with added distractions in several settings such as pet stores, hiking trails, dog friendly businesses and restaurants, etc.",
        included: [
          "4 Weeks Intensive Training in the Trainer’s home with her pack",
          "6 In Home Private Training Sessions",
          "Handouts, relevant articles and weekly homework",
          "All training Equipment",
          "Picture and Video updates during your dog’s stay",
          "Two bonus tricks and solid understanding of ‘come’",
        ],
        cost: "$3500",
        expectations: [
          "Significant reduction in problem behaviors such as jumping on people, begging, barking and nipping, pulling on leash and pottying inside (potential elimination depending on severity)",
          "Dog has solid understanding of sit, down, wait, stay, leave it, drop it, gentle, settle, touch in moderate distraction situations",
          "Ability to Loose Leash Walk",
        ],
        // image: "btAdult",
      },
      {
        programName: "Peace of Mind Program",
        definition:
          "Would you like having all of your dog’s training completed as quickly and efficiently as possible? If so, this is the program for you. I will do all of the work training your dog and will teach you the necessary information by meeting once per week for the duration of the dog’s stay. All learned behaviors will be proofed in many high distraction areas.",
        included: [
          "6 Weeks Intensive Training in the Trainer’s home with her pack",
          "8 In Home Private Training Sessions",
          "Handouts, relevant articles and weekly homework",
          "All training Equipment",
          "Picture and Video updates during your dog’s stay",
        ],
        cost: "$4700",
        expectations: [
          "Elimination of problem behaviors such as jumping on people, begging, barking, nipping, pulling on leash and pottying inside",
          "Dog responds to cues in high distraction situations and demonstrates solid ‘come’ and loose leash walking",
          "Dog obeys the first time they are given a cue",
        ],
        // image: "btAdult",
      },
      {
        programName: "Feisty Fido; Behavior Modification Program",
        definition:
          "If your pup is overexcited, reactive, fearful or anxious consider this program to help your four legged friend overcome his issues. Once your pooch has met everyone and settled in we begin working on basic manners, impulse control and confidence building and then the root of his issues.",
        included: [
          "4 Weeks Intensive Training in the Trainer’s home with her pack",
          "8 In Home Private Training Sessions",
          "Handouts, relevant articles and weekly homework",
          "Picture and Video updates during your dog’s stay",
        ],
        cost: "$3800",
        expectations: [
          "Reduction in problem behaviors such as jumping on people, begging, barking and nipping, pulling on leash and pottying inside",
          "Dog has solid understanding of obedience in high distraction situations",
          "Owner has understanding of why the problem behavior occurs and how to manage/work on these behaviors from home",
        ],
        // image: "btAdult",
      },
    ],
    btPuppyPrograms: [
      {
        programName: "Puppy Primer Program",
        definition: `This program includes two weeks of intensive Board and Train to jumpstart your puppy’s
          education. Justine will work with your dog to teach basic manners, develop appropriate
          behaviors and discourage common problem behaviors. This is the program for you if you need a
          little help to get started on your dog’s training. This program will have your puppy jumpstarted
          on housebreaking, socialization and basic manners. Again, it takes a minimum of 21 days to form
          a habit. So, while this program will be infinitely beneficial to your puppy’s social and mental
          development you (the owner) will need the continue working with your puppy to form the habit.`,
        included: [
          "2 Weeks intensive training in the trainer’s home with her pack",
          "4 In Home Private Training Sessions – at pick up, midpoint, drop off and one follow up",
          "Homework and relevant articles for each training session",
          "Picture and Video updates during your pup’s stay",
          "Bath and Nail Trim",
          "Graduation Certificate: Puppy Class 100",
          "Access to the trainer via e-mail 24 hours a day (phone for immediate needs)",
        ],
        cost: "$1400",
        expectations: [
          "Reduction in problem behaviors such as jumping, barking, nipping and chewing.",
          "Pup has fundamental understanding of sit, down, wait, stay, leave it, drop it, gentle, off under low distractions.",
          "Pup understands ‘game show buzzer’ (noise that means no) and clicker training.",
          "Pup will understand that he is supposed to potty outside – keep in mind puppies aren’t reliably housetrained until 6 months old so keep supervision tight.",
          "Pup will have a minimum of half of its recommended socialization completed.",
          "Pup will be comfortable with body handling similar to what he may experience by a veterinarian or a groomer.",
          "Pup will be introduced to and comfortable with the crate.",
        ],
        // image: "btpuppy",
      },
      {
        programName: "Polite Puppy Program",
        definition: `This program is the primer program plus extras. Your puppy comes to live with me and I
          will teach him basic manners, loose leash walking, housetraining, crate training, and prevention
          of common unwanted behaviors; all of the essentials. Once Justine has taught your pup basic
          commands she will proof them (make the behavior more solid) by practicing the behaviors with
          added distractions in several settings such as pet stores, hiking trails, dog friendly businesses and
          restaurants, farmer’s markets etc. By the end of the Polite Puppy Program your dog will be able
          to perform basic obedience commands in most common settings under mild distractions.`,
        included: [
          "4 Weeks intensive training in the trainer’s home with her pack",
          "6 In Home Private Training Sessions – at pick up, one per week (3), at drop off & follow up",
          "Handouts, homework and relevant articles for each training session",
          "All traing Equipment - include head halter or front clip harness for leash walking",
          "Picture and Video updates during your pup’s stay",
          "Bath and Nail Trim",
          "Graduation Certificate: Puppy Manners 101 & 102",
          "Access to the trainer via e-mail 24 hours a day (phone for immediate needs)",
        ],
        cost: "$2600",
        expectations: [
          "Significant reduction in problem behaviors such as jumping on people, begging, barking and nipping, pulling on leash and pottying inside (elimination depending on severity and age of pup).",
          "Pup has solid understanding of sit, down, wait, stay, leave it, drop it, gentle, settle (go to place/mat), touch in high distraction situations.",
          "Solid understanding of ‘come’ in most mildly distracting scenarios.",
          "Ability to loose leash walk.",
          "Bonus : One additional trick.",
          "Pup understands ‘game show buzzer’ (noise that means no) and clicker training.",
          "Pup is 100% potty trained, understands that he is supposed to potty outside, and will ring bell to indicate – keep in mind puppies aren’t reliably housetrained until 6 months old so keep supervision tight.",
          "Pup is completely socialized in several safe environments.",
          "Pup will be comfortable with body handling similar to what he may experience by a veterinarian or a groomer.",
          "Pup is 100% crate trained.",
          "Pup learns to pay attention and focus.",
        ],
        // image: "btpuppy",
      },
      {
        programName: "Perfect Puppy Program",
        definition: `Would you like having ALL of your dog’s training completed as quickly and efficiently as possible?
          If so, this is the program for you. Justine will do all of the work training your dog and will teach you all of
          the necessary information by meeting once per week for the duration of the puppy’s stay. All of the
          learned behaviors will be proofed (made solid) by working in as many high distraction areas as
          possible. The key to having a dog that responds to commands in any situation is thousands of
          repetitions in every situation imaginable. Allow me to perform all of the tedious repetition with your
          dog while you relax and enjoy the peace of mind knowing you will have an obedient well-mannered
          dog.`,
        included: [
          "6 Weeks intensive training in the trainer’s home with her pack",
          "8 In Home Private Training Sessions – at pick up, at the completion of each week of B&T (5), at drop off and follow up",
          "Handouts, homework and relevant articles for each training session",
          "All traing Equipment - include head halter or front clip harness for leash walking",
          "Picture and Video updates during your pup’s stay",
          "Bath and Nail Trim",
          "Graduation Certificate: Obedience 210",
          "Access to the trainer via e-mail 24 hours a day (phone for immediate needs)",
        ],
        cost: "$3600",
        expectations: [
          "Elimination in problem behaviors such as jumping on people, begging, barking and nipping, pulling on leash and pottying inside.",
          "Pup can sit, down, wait, stay, leave it, drop it, gentle, settle (go to place/mat), touch in high distraction situations.",
          "Solid understanding of ‘come’ in most mildly distracting scenarios.",
          "Ability to loose leash walk, even in high distraction situations.",
          "Bonus : One additional trick.",
          "Pup understands ‘game show buzzer’ (noise that means no) and clicker training.",
          "Pup is 100% potty trained, understands that he is supposed to potty outside, and will ring bell to indicate – keep in mind puppies aren’t reliably housetrained until 6 months old so keep supervision tight.",
          "Pup is completely socialized in several safe environments.",
          "Pup will be comfortable with body handling similar to what he may experience by a veterinarian or a groomer.",
          "Pup is 100% crate trained.",
          "Pup learns to pay attention and focus, what is appropriate to chow one (and what isn't), and learns self-control.",
          "Pup offers calm polite behavior to get what he wants",
        ],
        // image: "btpuppy",
      },
    ],
    dayTrainingPrograms: [
      {
        programName: "Simply Manners Day Training Program",
        definition:
          "This program covers your bases to have a calm, polite four legged family member. If you’re looking for your pooch to be more attentive, to listen better and to understand basic commands this is the package for you! You will be taught the initial stages of most basic obedience commands, the key elements of how dogs learn and how to provide your pooch with routine and structure.",
        included: [
          "3 Private In Home Training Sessions at a time convenient for you",
          "4 Day Training Sessions - Let Justine do some of the repetition for you!",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Training Equipment for each session",
          "Sit, Down, Stay, Wait, Gentle, Leave It, Drop It, Touch",
          "Briefly cover common problem behaviors; housebreaking, jumping up, barking, etc.",
          "Handouts, related articles and weekly homework",
          "Graduation Certificate: Basic Obedience",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$790",
        expectations: [
          "Basic understanding of why dogs do what they dog and how they learn",
          "Basic understanding of how to solve/prevent common problem behaviors",
          "Dog will have basic knowledge of obedience skills, and will be able to perform these skills fluently indoors",
        ],
        image: "program_dt_simply_manners",
      },
      {
        programName: "Simply Manners Plus Leash Walking Day Training Program",
        definition:
          "Does your dog need to learn manners both inside and on a leash? If so, this may be the program for you. You will be taught the fundamental skills to train your dog the early stages of basic manners and loose leash walking. To help you achieve your goal faster Justine will spend time practicing both basic obedience and leash manners during day training sessions.",
        included: [
          "5 One Hour Private In Home Lessons",
          "5 Day Training Lesson",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Sit, Down, Stay, Wait, Gentle, Leave It, Drop It, Touch, Come, Beginning Recall (come when called) + Loose Leash Walking",
          "Briefly cover common problem behaviors; housebreaking, jumping up, barking, etc.",
          "Handouts, related articles and weekly homework",
          "Photo of you and your pooch",
          "Graduation Certificate: Intermediate Obedience",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$1150",
        expectations: [
          "Understand why dogs do what they dog and how they learn",
          "Understand how to solve/prevent common problem behaviors",
          "Reduction in problem behaviors",
          "Dog will have basic knowledge of obedience skills",
          "Early stages of recall (coming when called)",
          "These skills will be reliable indoors and on leash due to extra practice with the trainer",
          "Human will understand how to begin teaching a loose leash walk",
          "Dog will have the beginnings of a reliable loose leash walk that will be heavily reinforced by one on one day training sessions with the trainer",
        ],
        image: "program_dt_simply_manners_plus_leash",
      },
      {
        programName: "Ultimate Family Dog Day Training Program",
        definition:
          "This is the package for the dog owners who want to be involved in their dog’s education and take that education to the next level. Includes Simply Manners plus Leash Walking. Now that your pooch knows what each command means how do we ensure that he performs every time you ask, no matter what? Justine will be happy to teach you! If you need your pooch to respond well in environments beyond the house or more difficult scenarios let me do those repetitions for you too! This is where you dog and I might pick the kids up at the bus stop, go on a field trip to a park or anywhere that may be beneficial to your dog’s learning process for life with you.",
        included: [
          "8 One Hour Private In Home Lessons",
          "10 Day Training Sessions",
          "FREE Follow Up Session upon completion for Real World Application",
          "Training Equipment (including Head Halter or Front Clip Harness and Long line)",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Sit, Down, Stay, Wait, Gentle, Leave It, Drop It, Touch, Come, Loose Leash Walking, Recall (come when called) and a few tricks!",
          "Learn how to generalize these behaviors so your dog performs in all situations.",
          "Handouts, related articles and weekly homework",
          "CGC, or Canine Good Citizen, testing can be added on for $25",
          "Photo of you and your pooch",
          "5% Discount on future Services including boarding",
          "Graduation Certificate: Advanced Obedience",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$1975",
        expectations: [
          "Understand why dogs do what they dog and how they learn",
          "Understand how to solve/prevent common problem behaviors",
          "Reduction, possible elimination, in problem behaviors",
          "Dog and human will understand how to work as a team and use their obedience skills in most scenarios",
          "Your dog will recieve one on one practice using his obedience skills in public with the trainer during day training sessions",
          "Human will understand how to teach a loose leash walk",
          "Dog will loose leash walk",
          "Your dog will have a lot of practive loose leash walking in parks, Broad Ripple, or other distracting areas with one on one guidance from the trainer.",
        ],
        image: "program_dt_ultimate_family_dog",
      },
      {
        programName: "Feisty Fido - Behavioral Modification Program",
        definition:
          "This is the program for dogs who have issues beyond what basic manners can repair (shy, overexcited and reactive dogs) and the owners who want to actively help their dog to recovery. We will begin by learning manners to help your pooch learn to focus and work for what he wants. After you and your dog have learned basic commands and how to work as a team Justine will tailor make a plan to address your specific needs. Frequently this includes teaching you Behavior Adjustment Training and/or Counter Conditioning/Desensitization. This program may or may not include leash walking depending on your dog’s specific needs.",
        included: [
          "6 One Hour Private In Home Lessons",
          "15 Day Training Sessions",
          "2 FREE Follow Up Sessions upon completion for Real World Application",
          "Training Equipment (including Head Halter or Front Clip Harness and a Long line)",
          "Learn how to earn the respect of your dog using Force-Free methods",
          "Basic Obedience commands - depend on your needs - Focus wil be on teaching your pooch calm, polite behavior.",
          "Handouts, related articles and weekly homework",
          "Photo of you and your pooch",
          "10% Discount on future Services including boarding",
          "Graduation Certificate: Life Skills",
          "Access to the Trainer via Phone and E-mail",
        ],
        cost: "$2275",
        expectations: [
          "This will depend on why you need this program. You can expect that your dog’s issues with (fear towards dogs/people/travel, reactivity towards people/dogs, guarding of toys/food/people, hyperactivity/not being able to settle, etc.) will be at a manageable place if not resolved by the end of this program.",
          "NOTE: Depending on your particular situation your dog may require more or fewer sessions.",
        ],
        image: "program_dt_fiesty_fido",
      },
    ],
  }))
);

// const toastFor = (action, successMessage, successCode = 0) => ({
//   message: action.payload?.message || successMessage,
//   statusCode: action.payload?.statusCode || successCode
// });

// Create protected page hook
// export const useProtected = (toastMessage = 'You must be signed in to view this page') => {
//   const { dispatch, user } = useStore();
//   const history = useHistory();

//   useEffect(() => {
//     if (!user.token) {
//       dispatch({ type: actions.TOAST, payload: { message: toastMessage , statusCode: 1 } });
//       history.replace('/login');
//     }
//   }, [user]);
// };
